import { InlineWidget } from 'react-calendly';

const Calendly = ({ url = '' }) => {
  return (
    <div>
      <InlineWidget
        url={url || 'https://calendly.com/smat/discovery-call'}
        styles={{
          height: '900px',
          overflow: 'hidden'
        }}
      />
    </div>
  );
};

export default Calendly;
